import { twMerge } from "tailwind-merge";

const ButtonsAndViewsGroup = ({
    className = "",
    visible = true,
    buttonsGroupClassName = "",
    buttonsGroup = [],
    viewsGroupClassName = "",
    viewsGroup = [],
}) => {
    return (
        visible && (
            <div className={twMerge("absolute flex  space-x-2", className)}>
                <div className="flex w-10 flex-col space-y-3">
                    {buttonsGroup.map((groups, id) => (
                        <div
                            key={id}
                            className={twMerge(
                                "flex flex-col items-center space-y-1",
                                buttonsGroupClassName
                            )}
                        >
                            {groups.map((button, id) => (
                                <button.type key={id} {...button.props} />
                            ))}
                        </div>
                    ))}
                </div>
                <div
                    className={twMerge(
                        "flex flex-col items-start justify-start",
                        viewsGroupClassName
                    )}
                >
                    {viewsGroup.map((sideView, id) => (
                        <sideView.type key={id} {...sideView.props} />
                    ))}
                </div>
            </div>
        )
    );
};

export default ButtonsAndViewsGroup;
